'use strict';

angular.module('portal.applications')
    .controller('PortalApplicationsCheckout', ['$scope', '$rootScope', '$stateParams', '$state', function ($scope, $rootScope, $stateParams, $state) {
        $scope.redirectImmediately = $stateParams.redirectImmediately;

        $rootScope.$on('generate:pdf', function () {
            $rootScope.generatingPDF = true;
        });

        if ($scope.redirectImmediately == true) {
            $rootScope.generatingPDF = false;
            $state.go('portal.menus.checkoutlist');
        }

        $rootScope.$on('reset:application', function () {
            $rootScope.generatingPDF = false;
            $state.go('portal.menus.checkoutlist');
        });

        window.onbeforeunload = function (e) {
            if ($rootScope.generatingPDF) {
                var message = "", e = e || window.event;
                // For IE and Firefox
                if (e) {
                    e.returnValue = message;
                }

                // For Safari
                return message;
            }
        };
    }])
;